const gbTrialBlack = {
  FORMS: [
    {
      type: 'trial-contact-form',
      name: 'TrialContactForm',
      message: {
        open: 'Formulario contacto',
        send: 'Envío Formulario De Contacto'
      }
    }
  ],
  CSS: {
    id: '64d9200b6f964c7f5a4c4a72',
    name: 'gb-trial-black',
    avatar: {
      name: 'Chatbot',
      header: 'https://chatbotqa.gatblac.com/static/avatar/gatblac-trial/avatar-black-close.png',
      new: 'https://chatbotqa.gatblac.com/static/avatar/gatblac-trial/avatar-black-new.png',
      open: 'https://chatbotqa.gatblac.com/static/avatar/gatblac-trial/avatar-black-open.png',
      close: 'https://chatbotqa.gatblac.com/static/avatar/gatblac-trial/avatar-black-close.png'
    },
    style: {
      score: {
        inactiveColor: '#fff',
        activeColor: '#000000',
        borderColor: '#000000'
      }
    }
  }
}

export default gbTrialBlack
